/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";

const { state } = store("create-block", {
  state: {
    hasVisibleClass: false,
    isHidden: false,
  },

  actions: {
    toggleClass() {
      const context = getContext();
      context.isOpen = !context.isOpen;
      state.hasVisibleClass = !state.hasVisibleClass;
      if (!state.hasVisibleClass) {
        state.isHidden = !state.isHidden;
      }

      if (state.hasVisibleClass) {
        state.isHidden = false;
      } else {
        state.isHidden = true;
      }
    },
  },
});
